{
  "browserNotSupported": {
    "title": "Modulen kunne ikke lastes",
    "text": "For å bruke deleleseren, bytt til en oppdatert nettleser."
  },
  "main": {
    "more": "Mer tilbehør",
    "findMore": "Du kan finne tilbehør for ettermontering/konvertering og oppgradering av kjøretøyet ditt her i vårt omfattende utvalg. Tilbehøret du har valgt vil bli sendt til din {{brand}} sammen med kjøretøyforespørselen.",
    "topOffers": "TOPP-tilbud",
    "article": "<0>{{min}} - {{max}} / </0>{{productCount}} Produkter",
    "noArticleFound": "0 Produkter",
    "oemHint": "Velg matchende tilbehør til din {{brand}} nå!",
    "noBrand": "Velg matchende tilbehør til kjøretøyet ditt nå!",
    "outOfOrder": "Dessverre er det ingen produkter tilgjengelig for øyeblikket.<0/>Vi holder for tiden på å oppdatere katalogen vår.<0/>Vennligst kom tilbake på et senere tidspunkt.",
    "nextSlide": "Neste",
    "prevSlide": "Forrige"
  },
  "cart": {
    "add": "Produkt lagt til kjøretøy",
    "fullPrice": "Pris kjøretøy og tilbehør",
    "priceWithoutCar": "Pris tilbehør"
  },
  "navigation": {
    "zoom": "Zoom",
    "toggleSearch": "Bytt søk",
    "cart": "Handlekurv",
    "cartDelete": "Fjern produkt fra handlekurv",
    "vehicle": "Valgt kjøretøy",
    "maxBookmarksReached": "Maksimalt 15 produkter nådd",
    "filter": {
      "toggleFilter": "Bytt filter",
      "topProducts": "TOPP-tilbud",
      "reset": "Tilbakestill filter",
      "ready": "Ferdig",
      "show": "Vis resultater"
    },
    "searching": {
      "submit": "Søk",
      "close": "Lukke",
      "placeholder": "Finn matchende tilbehør ...",
      "suggestions": "Søkeforslag",
      "categories": "Kategorier",
      "products": "Produkter",
      "productCount": "{{count}} produkt",
      "productCount_other": "{{count}} produkter",
      "showAll": "Vis {{count}} resultat",
      "showAll_other": "Vis alle {{count}} resultater",
      "expand": "Utvidet søk",
      "show": "Vis resultater",
      "found": {
        "withCategory": "Søkeresultater for \"{{fuzzy}}\" i kategorien \"{{category}}\"",
        "withOutCategory": "Søkeresultater for \"{{fuzzy}}\" fra alle kategorier"
      }
    },
    "share": "Del",
    "back": "Tilbake",
    "details": "Detaljer",
    "add": "Legg til",
    "remove": "Fjern",
    "close": "Lukk",
    "filtern": "Filter",
    "closeFilter": "Lukk filteret"
  },
  "productDetail": {
    "gallery": {
      "jumpToImageNumber": "Gå til bilde {{number}}"
    },
    "articleNumber": "Artikkelnummer",
    "relatedArticle": "Disse artiklene kunne også interessere deg:",
    "brand": "Merke",
    "priceBox": {
      "withVatAndMounting": "inkl. mva. & montering",
      "withVat": "inkl. mva.",
      "recommendedRetailPrice": "Veiledende pris",
      "historicMinimalPurchasePrice": "Laveste pris de siste 30 dagene",
      "priceDetails": "Prisinformasjon",
      "priceDetailsHeadline": "Detaljer om prisen for denne varen",
      "priceToday": "Pris for denne varen i dag",
      "priceDetails30Days": "Laveste pris i løpet av de 30 dagene før prisendringen",
      "close": "Lukk",
      "addItem": "Legg til artikkel",
      "removeItem": "Fjern artikkel"
    },
    "infoBox": {
      "description": "Beskrivelse",
      "vehicles": "Passer for følgende modeller",
      "empty": "Det er ingen spesielle kjøretøyoppdrag for dette produktet.",
      "contacts": "Produsent"
    },
    "contacts": {
      "manufacturer-contact": "Produsentens kontaktinformasjon",
      "responsible-contact": "Ansvarlig person i EU",
      "trademark": "Merke"
    }
  },
  "productList": {
    "oemHint": "Originalt tilbehør til {{brand}}"
  }
}
